<template>
  <div class="audienceHeader-card-header">
    <span class="card-header__title">
      {{$t('feed.audit.audience.period')}}:
      <b>{{periodName}}</b>
    </span>
    <period-range :chart-name="chartName"/>
  </div>
</template>

<script>
  // components
  import PeriodRange from "../../../../../../../../components/auditPeriodRange/PeriodRange";

  export default {
    name: "AudienceHeader",
    props: {
      chartName: {
        type: String
      }
    },
    computed: {
      periodName() {
        return this.$store.getters.auditPeriodName(this.chartName, this.$i18n);
      }
    },
    components: {
      PeriodRange
    }
  };
</script>

<style>
  @import "../../../../../../../../style/cardHeaderTitle.css";
  .audienceHeader-card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
  }
</style>
